import * as actionType from "./actionTypes";
import { createReducer, updateObject } from "../../utils/reducerUtils";
import { loadPricingPrefs } from "../localStorage";

//South African visitors see rand (PayFast) first, everyone else dollars (PayPal)
const guessCurrency = () => {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    return (zone === "Africa/Johannesburg") ? "ZAR" : "USD";
  }
  catch (e) {
    return "ZAR";
  }
};

const saved = loadPricingPrefs() || {};

/* State shape same as initial state
*/
const initialState = {
  //Active plans for the pricing page, in display order
  plans: null,
  //"ZAR" (PayFast) or "USD" (PayPal) - remembered per visitor
  currency: (saved.currency === "ZAR" || saved.currency === "USD") ? saved.currency : guessCurrency(),
  //Annual is shown first
  interval: (saved.interval === "Monthly") ? "Monthly" : "Annual",
};

const setPlans = (state, action) => (
  updateObject(state, {
    plans: action.plans,
  })
);

const setPricingPrefs = (state, action) => (
  updateObject(state, action.prefs)
);

const reducer = createReducer(initialState, {
  [actionType.SET_PLANS]: setPlans,
  [actionType.SET_PRICING_PREFS]: setPricingPrefs,
});

export default reducer;

// SELECTORS
export const getPlans = (state) => state.plans;

export const getPlan = (state) => (
  (code) => (state.plans ? state.plans.find((x) => x.code === code) || null : null)
);

export const getCurrency = (state) => state.currency;
export const getInterval = (state) => state.interval;
